export var defaultProps = {
    className: '',
    offsetTop: -1,
    offsetBottom: -1,
    initFixed: false,
    outFixed: false,
    target: function () { return document.body; },
};
